module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/fancy-box/fancy-box-effect/fancy-box-effect.component.scss
// module id = ./src/app/features/fancy-box/fancy-box-effect/fancy-box-effect.component.scss
// module chunks = main